import theme from '@/utils/styles-variables';

const wysiwyg = () => {
  return `
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        color: #000;
        white-space: pre-line;
        
        strong {
          font-weight: 700;
        }
        
        em {
          font-style: italic;
        }
        
        del {
          text-decoration: line-through;
        }
        
        h3, h4, h5, h6 {
          color: ${theme.colors.black};
          font-family: ${theme.fonts.grosa};
          margin-bottom: 24px;
        }
        
        h3 {
          font-size: 30px;
          line-height: 40px;
        }
        
        h4 {
          font-size: 20px;
          line-height: 24px;
        }
        
        h5 {
          font-size: 18px;
          line-height: 24px;
        }
        
        h6 {
          font-size: 16px;
          line-height: 24px;
          text-transform: uppercase;
        }
        a {
            display: inline;
            cursor: pointer;
            text-decoration: underline;
        }
        
        blockquote {
          display: block;
          margin: 0;
          border-left: 2px solid #F46262;
          padding-left: 25px;
        }
        
        ol,
        ul {
            display: block;
            margin: 0;
            padding-left: 25px;
        }
        
        ul {
            li {
                list-style-type: disc;
            }
        }
        
        ol {
            li {
                list-style-type: decimal;
            }
        }
 
      code {
        display: block;
        font-family: monospace;
        padding: 20px;
        background-color: #F7F4F2;
      }
    `;
};

export { wysiwyg };
